var map = {
	"./Heco-logo.png": 489,
	"./arrow-down-blue.svg": 490,
	"./arrow-down-grey.svg": 491,
	"./arrow-right-white.png": 492,
	"./arrow-right.svg": 493,
	"./big_unicorn.png": 238,
	"./blockscan.svg": 494,
	"./blue-loader.svg": 75,
	"./bnb.svg": 495,
	"./circle-grey.svg": 496,
	"./circle.svg": 497,
	"./coinbaseWalletIcon.svg": 148,
	"./default_coin.png": 245,
	"./dropdown-blue.svg": 498,
	"./dropdown.svg": 499,
	"./dropup-blue.svg": 500,
	"./ethereum-logo.png": 246,
	"./fortmaticIcon.png": 149,
	"./goswap_logo.png": 146,
	"./goswap_logo_dark.png": 147,
	"./kline_area.svg": 501,
	"./kline_candle.svg": 502,
	"./kto.png": 247,
	"./link.svg": 503,
	"./magnifying-glass.svg": 504,
	"./menu.svg": 505,
	"./metamask.png": 244,
	"./noise.png": 240,
	"./plus-blue.svg": 506,
	"./plus-grey.svg": 507,
	"./portisIcon.png": 150,
	"./question-mark.svg": 508,
	"./question.svg": 509,
	"./spinner.svg": 510,
	"./token-list/lists-dark.png": 511,
	"./token-list/lists-light.png": 512,
	"./token-logo.png": 117,
	"./trustWallet.png": 513,
	"./twitter.svg": 514,
	"./walletConnectIcon.svg": 151,
	"./website.svg": 515,
	"./x.svg": 516,
	"./xl_uni.png": 239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;